 import 'babel-polyfill';
 require('bootstrap');
import React from 'react';
import ReactDOM from 'react-dom';
import MoreArticles from './components/MoreArticles';

//require('../fonts/fonts.css');
require('../sass/main.scss');

require('slick-carousel');
require('./general.js');

let currentPage;
if(document.body.classList.contains('home')){// is front page
	currentPage = 'HOME';
}else if(document.body.classList.contains('blog')){
	currentPage = 'BLOG';
}else if(document.body.classList.contains('archive')){
	currentPage = 'ARCHIVE';
}else if(document.body.classList.contains('single')){
	currentPage = 'SINGLE';
}else if(document.body.classList.contains('search')){
	currentPage = 'SEARCH';
}else{
	currentPage = 'DEFAULT';
}

const browseMoreGrid = document.getElementById('browse-more');
const browseMoreList = document.getElementById('browse-more-list');


if(browseMoreGrid){
	 ReactDOM.render(<MoreArticles currentpage={currentPage} type="GRID"/>, browseMoreGrid); //front page
}
if(browseMoreList){
	const searchterm = browseMoreList.getAttribute('searchterm');
	if(searchterm){
		ReactDOM.render(<MoreArticles currentpage={currentPage} type="LIST" searchterm={searchterm} />, browseMoreList);
	}else{
		ReactDOM.render(<MoreArticles currentpage={currentPage} type="LIST" />, browseMoreList);
	}
	
}


// WEBPACK FOOTER //
// ./js/index.js